import React from "react";


  const RefundConfirmModal = ({ onProceed, onClose, finalConfirm = false, isLoading = false }) => (
    <div className="other-purchase-modal-overlay">
      <div className="other-purchase-modal-content">
        <h2>Refund {finalConfirm ? "Confirmation" : "?"}</h2>

        {!finalConfirm ? (
          <>
            <p>
              Please note that your refund request will be reviewed by the Host.
              If approved, a refund will be processed. However, the full amount
              may not be returned.
            </p>
            <img
              src="/images/crying_face.png"
              alt="Refund"
              className="purchase-celebration-img"
            />
            <p className="purchase-confirm-note">
              This action cannot be undone. Once submitted, your request will be
              reviewed by the event host.
            </p>
          </>
        ) : (
          <>
            <img
              src="/images/crying_face.png"
              alt="Final Refund Confirmation"
              className="purchase-celebration-img"
            />
            <p
              className="purchase-confirm-note"
              style={{ fontWeight: "700", color: "#D42620" }}
            >
              Are you sure you want to proceed with this refund?
            </p>
          </>
        )}

        <div className="modal-controls">
          <button
            className="modal-button other-purchase-cancel"
            onClick={onClose}
          >
            Close
          </button>
          <button
            className="modal-button proceed-button"
            onClick={onProceed}
            disabled={isLoading}
          >
            {isLoading ? "Submitting refund..." : "Proceed"}
          </button>
        </div>
      </div>
    </div>
  );

  export default RefundConfirmModal